// extracted by mini-css-extract-plugin
export default {"btn":"WelcomeModal_btn__heul0","btnRestore":"WelcomeModal_btnRestore__OErLB"};